class HelmetActions {
  constructor() {
    this.generateActions('update', 'updateTitleSuccess', 'updateTitleFail', 'updateMetas');
  }

  updatePrimaryContentSourceTitle(title) {
    return (dispatch, alt) =>
      alt.resolve(async() => {
        try {
          this.updateTitleSuccess('primaryContentSource', title);
        } catch (error) {
          this.updateTitleFail({ error });
        }
      });
  }

  updateRouteTitle(title) {
    return (dispatch, alt) =>
      alt.resolve(async() => {
        try {
          this.updateTitleSuccess('route', title);
        } catch (error) {
          this.updateTitleFail({ error });
        }
      });
  }
}

export default HelmetActions;



// WEBPACK FOOTER //
// ./app/flux/actions/Helmet.js